/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */

import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Notification } from '@tripian/react';

import ICombinedState from '../../redux/model/ICombinedState';
import { hideError as hideErrorUser } from '../../redux/action/user';
import { hideError as hideErrorTrip } from '../../redux/action/trip';

interface INotifyError {
  positionX?: 'left' | 'center' | 'right';
  positionY?: 'top' | 'bottom';
}

const NotifyError: React.FC<INotifyError> = ({ positionX = 'right', positionY = 'top' }) => {
  const { userErrors, tripErrors } = useSelector((state: ICombinedState) => ({ userErrors: state.user.errors, tripErrors: state.trip.errors }));
  const dispatch = useDispatch();

  const shownUserError = useMemo(() => userErrors.find((error) => error.hide === false), [userErrors]);

  const shownTripError = useMemo(() => tripErrors.find((error) => error.hide === false), [tripErrors]);

  let shownErrorType: 'userError' | 'tripError' = 'userError';
  let shownMessage: {
    id: number;
    functionName: string;
    title: string;
    message: string;
    hide: boolean;
  };

  if (shownUserError?.message) {
    shownErrorType = 'userError';
    shownMessage = shownUserError;
  } else if (shownTripError?.message) {
    shownErrorType = 'tripError';
    shownMessage = shownTripError;
  } else return null;

  const onClose = (id: number, errorType: 'userError' | 'tripError') => {
    if (errorType === 'userError') dispatch(hideErrorUser(id));
    else dispatch(hideErrorTrip(id));
  };

  return (
    <>
      <Notification
        type="error"
        positionX={positionX}
        positionY={positionY}
        title={`${shownMessage.title} error`}
        // eslint-disable-next-line no-constant-condition
        message={typeof (shownMessage.message === 'string') ? shownMessage.message : JSON.stringify(shownMessage.message)}
        onClose={() => {
          onClose(shownMessage?.id, shownErrorType);
        }}
        closeMs={3500}
      />
    </>
  );
};

export default NotifyError;
